module.exports = __webpack_public_path__ + "img/icon-folder-light.22532e97.svg";